import * as tslib_1 from "tslib";
import { Api } from '../api/api';
import * as i0 from "@angular/core";
import * as i1 from "../api/api";
var NotifyService = /** @class */ (function () {
    function NotifyService(api) {
        this.api = api;
    }
    NotifyService.prototype.notifyByEmail = function (emailItem) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.post('api/notify/email', emailItem)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotifyService.ngInjectableDef = i0.defineInjectable({ factory: function NotifyService_Factory() { return new NotifyService(i0.inject(i1.Api)); }, token: NotifyService, providedIn: "root" });
    return NotifyService;
}());
export { NotifyService };
